import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { FUTURE_EXPENSES_STATISTICS_GET } from 'api/query-keys';
import type { TGetFutureExpensesStatisticsRes } from 'api/swagger';

export const useGetFutureExpensesStatistics = () => {
  return useQuery<TGetFutureExpensesStatisticsRes>({
    queryKey: [FUTURE_EXPENSES_STATISTICS_GET],
    queryFn: async () => {
      const { data } = await http.get<TGetFutureExpensesStatisticsRes>('/v1/statistics/future-expenses');
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
};
